import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";

const Form = ({ match }) => (
  <div className="app-wrapper" style={{ padding: 0 }}>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/home`} />

      <Route
        path={`${match.url}/home`}
        component={asyncComponent(() => import("./routes/home"))}
      />

      <Route
        path={`${match.url}/menu`}
        component={asyncComponent(() => import("./routes/menu"))}
      />

      <Route
        path={`${match.url}/suscripcion`}
        component={asyncComponent(() => import("./routes/suscripcion"))}
      />

      <Route
        path={`${match.url}/new-subscription`}
        component={asyncComponent(() => import("./routes/new-subscription"))}
      />

      <Route
        path={`${match.url}/plan-amigo`}
        component={asyncComponent(() => import("./routes/plan-amigo"))}
      />

      <Route
        path={`${match.url}/alta-plan-amigo/:id`}
        component={asyncComponent(() => import("./routes/alta-plan-amigo"))}
      />

      <Route
        path={`${match.url}/success`}
        component={asyncComponent(() => import("./routes/success"))}
      />

      <Route
        path={`${match.url}/pagocorrecto`}
        component={asyncComponent(() => import("./routes/pagocorrecto"))}
      />

      <Route
        path={`${match.url}/success-regalo`}
        component={asyncComponent(() => import("./routes/success-regalo"))}
      />

      <Route
        path={`${match.url}/success-testudo`}
        component={asyncComponent(() => import("./routes/success-testudo"))}
      />

      <Route
        path={`${match.url}/regala-suscripcion`}
        component={asyncComponent(() => import("./routes/regala-suscripcion"))}
      />

      <Route
        path={`${match.url}/club-testudo`}
        component={asyncComponent(() => import("./routes/club-testudo"))}
      />

      <Route
        path={`${match.url}/quienes-somos`}
        component={asyncComponent(() => import("./routes/quienes-somos"))}
      />

      <Route
        path={`${match.url}/contacto`}
        component={asyncComponent(() => import("./routes/contacto"))}
      />

      <Route
        path={`${match.url}/register`}
        component={asyncComponent(() => import("./routes/register"))}
      />
      <Route
        path={`${match.url}/cancel`}
        component={asyncComponent(() => import("./routes/cancel"))}
      />

      <Route
        path={`${match.url}/facturas`}
        component={asyncComponent(() => import("./routes/facturas"))}
      />

      <Route
        component={asyncComponent(() =>
          import("app/routes/extraPages/routes/404")
        )}
      />
    </Switch>
  </div>
);

export default Form;



// WEBPACK FOOTER //
// ./app/routes/inicio/index.js